<script setup lang="ts">
const props = defineProps({
  path: String,
  titleGraphic: String,
  titleGraphicAlt: String,
  categoryGraphic: String,
});
</script>

<template>
  <router-link :to="{ name: props.path }">
    
    <!-- Left -->
    <div class="left">
      
      <!-- Title -->
      <div class="title">
        <img :alt="props.titleGraphicAlt"
             :src="props.titleGraphic" />
      </div>
      
      <!-- Arrow -->
      <div class="arrow">
        <q-icon color="white"
                name="fa-solid fa-arrow-right"
                size="24px" />
      </div>
    </div>
    
    <!-- Image -->
    <div class="image">
      <img :src="props.categoryGraphic" />
    </div>
  </router-link>
</template>

<style lang="scss" scoped>
a {
  $padding: 12px;

  display: flex;
  justify-content: space-between;
  height: 238px;
  padding-left: $padding;
  overflow: hidden;
  border-radius: 30px;
  margin-bottom: 35px;

  &:last-child {
    margin-bottom: 0;
  }

  // Left (contains: Title & Circle Arrow)
  .left {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding-bottom: $padding;

  }

  // Title
  .title img {
    width: 100%;
  }

  // Circle Arrow
  .arrow {
    $size: 58px;
    width: $size;
    height: $size;
    font-size: 24px;
    line-height: 52px;
    color: $white;
    text-align: center;
    border-radius: 50%;
  }

  // Image
  .image img {
    height: auto;
  }

  @media (max-width: 529px) {
    padding-right: $padding;

    // Image
    .image {
      display: none;
    }
  }

  // ROSA Knee
  &.rosa-knee { // <a>
    background-color: #d4e6f0;

    // Title
    .title {
      padding-top: 39px;
    }

    // Circle Arrow
    .arrow {
      background-color: $secondary;
    }

    // Image
    .image {
      padding-top: 18px;
      padding-right: 21px;

      img {
        width: 215px;
      }
    }
  }
}
</style>